import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';

import { AutosizeTextAreaComponent } from './components/AutosizeTextArea/autosize-text-area.component';
import { AutosizeTextAreaDirective } from './directives/autosizeTextArea/autosize-text-area.directive';
import { BrowseImageComponent } from './components/BrowseImage/browse-image.component';
import { ContactsComponent } from './components/Contacts/contacts.component';
import { ContentEditableBoxComponent } from './components/ContentEditableBox/content-editable-box.component';
import { DatePickerComponent } from './components/DatePicker/date-picker.component';
import { LinksComponent } from './components/Links/links.component';
import { NewsroomLeftSidebarComponent } from './components/NewsroomLeftSidebar/newsroom-left-sidebar.component';
import { VideoInputComponent } from './components/VideoInput/video-input.component';
import { MiscModule } from '../../Common/Misc/misc.module';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { EditorModule } from 'primeng/editor';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { FilterModule } from '../../Common/Filter/filter.module';
import { NewsroomLeftSidebarService } from '../../News/Newsroom/services/newsroom-left-sidebar.service';
import { LocalizationModule } from '@Core/Localization/localization.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        EditorModule,
        ReactiveFormsModule,
        DatePickerModule,
        SelectModule,
        TooltipModule,
        MiscModule,
        CommonBasicModule,
        CommonFormsModule,
        ClickOutsideModule,
        FilterModule,
        LocalizationModule,
    ],
    declarations: [
        AutosizeTextAreaComponent,
        AutosizeTextAreaDirective,
        BrowseImageComponent,
        ContactsComponent,
        ContentEditableBoxComponent,
        DatePickerComponent,
        LinksComponent,
        NewsroomLeftSidebarComponent,
        VideoInputComponent
    ],
    exports: [
        AutosizeTextAreaComponent,
        AutosizeTextAreaDirective,
        BrowseImageComponent,
        ContactsComponent,
        ContentEditableBoxComponent,
        DatePickerComponent,
        LinksComponent,
        NewsroomLeftSidebarComponent,
        VideoInputComponent
    ],
    providers: [
        NewsroomLeftSidebarService
    ]
})
export class NewsSharedModule {
}
